import smoothscroll from 'smoothscroll-polyfill';
import './assets/js/matches-polyfill'
import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import router from './router'
import store from './store'
import axios from 'axios'
import VueI18n from 'vue-i18n'
import Snotify from 'vue-snotify';
import moment from 'moment';

Vue.config.productionTip = false

smoothscroll.polyfill();

Vue.use(Vuex)
Vue.use(VueI18n)

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY')
  }
})
Vue.filter('formatDateDot', function (value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY')
  }
})

const options = {
  toast: {
    timeout: 5000,
    showProgressBar: false
  }
}
Vue.use(Snotify, options)

Vue.prototype.$http = axios

const messages = {
  bg: require('./locale/bg.json'),
  en: require('./locale/en.json'),
}

const i18n = new VueI18n({
  locale: 'bg',
  messages
})

const savedLang = localStorage.getItem('lang');

if (!savedLang) {
  axios.get(`${process.env.VUE_APP_BASE_URI}/countrycode`).then(
    response => {
      if (response.data) {
        if (response.data.countryCode.toLowerCase() == 'bg') {
          // for Bulgaria => Bulgarian
          i18n.locale = 'bg';
        } else {
          // for everywhere else => English
          i18n.locale = 'en';
        }
        localStorage.setItem('lang', i18n.locale);
      }
    },
    () => {
      console.log("Can't localize you.");
    }
  );
} else {
  i18n.locale = savedLang;
}


const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')